<div class="flex">
  <div class="w-[250px] lg:relative fixed left-0 top-0 block z-20 transition-all" [ngClass]="
      isToggled ? 'translate-x-0' : ' translate-x-[-100%] md:translate-x-0'
    ">
    <app-admin-sidebar (collapse)="handleCollapse($event)"></app-admin-sidebar>
  </div>
  <div class="w-full h-[100vh] overflow-y-auto overflow-x-hidden bg-[#F8F8F8] relative">
    <div class="absolute top-0 left-0 w-full" [ngClass]="isToggled ? 'activeMobile-header' : ''">
      <app-authenticated-header (toggle)="handleToggle($event)"></app-authenticated-header>
    </div>
    <div class="pt-[76px]"></div>
    <router-outlet></router-outlet>
  </div>
</div>